import Api from '../core/Api'
import Offline from "./Offline";
import localforage from 'localforage'

class Fuite {
    static addFuiteOnline(fuite) {
        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {
                    let idDossier = fuite.dossier;
                    let oldId = fuite.id;

                    fuite.etat = fuite.reparation;

                    delete fuite.order;
                    delete fuite.reparation;
                    delete fuite.id;
                    delete fuite.dossier;

                    delete fuite.created_at;
                    delete fuite.updated_at;

                    api
                        .post('/fuite/' + idDossier, fuite)
                        .then(res => {
                            if (!res.data.errors) {
                                this
                                    .getList()
                                    .then(list => {
                                        let newList = list.map(f => {
                                            if (f.id === oldId) {
                                                f.id = res.data.id
                                            }
                                            return f
                                        });

                                        localforage
                                            .setItem('listFuites', JSON.stringify(newList))
                                            .then(() => {
                                                Offline
                                                    .deleteAction(oldId, 'Fuite')
                                                    .then(() => resolve(true))
                                                    .catch(err => reject(err))
                                            })
                                            .catch(err => reject(err))

                                    })
                                    .catch(err => {
                                        if (err.response && (err.response.status === 403 || err.response.status === 404)){
                                            resolve(true)
                                        } else {
                                            reject(err)
                                        }
                                    })

                            } else {
                                reject(res.data.errors)
                            }

                        })
                        .catch(err => {
                            if (err.response && (err.response.status === 403 || err.response.status === 404)){
                                resolve(true)
                            } else {
                                reject(err)
                            }
                        })

                })
                .catch(err => reject(err))

        })
    }

    static updateFuiteOnline(fuite) {
        return new Promise((resolve, reject) => {

            let idFuite = fuite.id;

            fuite.etat = fuite.reparation;

            delete fuite.reparation;
            delete fuite.dossier;
            delete fuite.id;

            delete fuite.created_at;
            delete fuite.updated_at;

            Api
                .init()
                .then(api => {
                    api
                        .put('/fuite/' + idFuite, fuite)
                        .then(res => {

                            if (!res.data.errors) {

                                Offline.deleteAction(idFuite, 'Fuite').then(() => {
                                    return resolve(true)
                                })

                            } else {
                                reject(res.data.errors)
                            }

                        })
                        .catch(err => {
                            if (err.response && (err.response.status === 403 || err.response.status === 404)){
                                resolve(true)
                            } else {
                                reject(err)
                            }
                        })

                })
                .catch(err => reject(err))

        })
    }

    static removeFuiteOnline(fuite) {

        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {

                    api
                        .delete('/fuite/' + fuite.id)
                        .then(() => {

                            this
                                .getList()
                                .then(list => {
                                    let newList = _.filter(list, f => f.id !== fuite.id);

                                    localforage
                                        .setItem('listFuites', JSON.stringify(newList))
                                        .then(() => {
                                            Offline.deleteAction(fuite.id, 'Fuite').then(() => {
                                                return resolve(true)
                                            })
                                        })
                                        .catch(err => reject(err))
                                })
                                .catch(err => reject(err))

                        })
                        .catch(err => {
                            if (err.response && (err.response.status === 403 || err.response.status === 404)){
                                resolve(true)
                            } else {
                                reject(err)
                            }
                        })

                })
                .catch(err => reject(err))
        })
    }

    // Offline CRUD (mirroir InformationInstallation.addInformationInstallationOffline/removeInformationInstallationOffline)
    static addFuiteOffline(fuite) {
        return new Promise((resolve, reject) => {
            this
                .getList()
                .then(list => {
                    list.push(fuite);

                    localforage
                        .setItem('listFuites', JSON.stringify(list))
                        .then(() => {
                            Offline
                                .saveAction({action: 'add', type: 'Fuite', id: fuite.id})
                                .then(() => resolve(true))
                                .catch(err => reject(err))
                        })
                        .catch(err => reject(err))
                })
                .catch(err => reject(err))
        })
    }

    static updateFuiteOffline(fuite) {
        return new Promise((resolve, reject) => {
            this
                .getList()
                .then(list => {
                    let index = _.findIndex(list, ['id', fuite.id]);

                    if (index === -1) {
                        return reject(new Error('fuite introuvable'))
                    }

                    list[index] = fuite;

                    localforage
                        .setItem('listFuites', JSON.stringify(list))
                        .then(() => {
                            Offline
                                .saveAction({action: 'update', type: 'Fuite', id: fuite.id})
                                .then(() => resolve(true))
                                .catch(err => reject(err))
                        })
                        .catch(err => reject(err))
                })
                .catch(err => reject(err))
        })
    }

    static removeFuiteOffline(id) {
        return new Promise((resolve, reject) => {
            this
                .getList()
                .then(list => {
                    let indexToDel = _.findIndex(list, ['id', id]);
                    list.splice(indexToDel, 1);

                    localforage
                        .setItem('listFuites', JSON.stringify(list))
                        .then(async () => {
                            await Offline.deleteAction(id, 'Fuite');

                            if (!_.includes(id, 'F-')) {
                                await Offline.saveAction({action: 'delete', type: 'Fuite', id: id});
                            }

                            resolve(true)
                        })
                        .catch(err => reject(err))
                })
                .catch(err => reject(err))
        })
    }

    static getFuite(id) {
        return new Promise((resolve, reject) => {
            this
                .getList()
                .then(list => {
                    if (!_.includes(id, 'F-')) {
                        id = parseInt(id)
                    }

                    resolve(_.find(list, ['id', id]))

                })
                .catch(err => reject(err))
        })
    }

    static getListForFibsdd(idFi) {

        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(list => {

                    if (!_.includes(idFi, 'N-')) {
                        idFi = parseInt(idFi)
                    }

                    let fuites = _.filter(list, el => {

                        if (el.dossier === idFi) {
                            return el
                        }
                    });

                    fuites = _.map(fuites, el => {
                        if (!el.hasOwnProperty('reparation')) {
                            el['reparation'] = el.etat
                        }

                        return el
                    });

                    resolve(fuites)

                })
                .catch(err => reject(err))
        })

    }

    static getList() {
        return new Promise((resolve, reject) => {
            localforage
                .getItem('listFuites')
                .then(res => { const parsed = JSON.parse(res); resolve(Array.isArray(parsed) ? parsed : []) })
                .catch(err => reject(err))
        })
    }

}

export default Fuite;



// WEBPACK FOOTER //
// ./src/js/models/Fuite.js